import Vue from 'vue'
import VueRouter from 'vue-router'

// Import views
import CityRouter  from './CityRouter.vue'

import Home from './views/Home.vue'
import Login from './views/Home/Login.vue'
import ForgotPassword from './views/Home/ForgotPassword.vue'
import Register from './views/Home/Register.vue'

import Return from './views/Return.vue'
import Deeplink from './views/Deeplink.vue'
import Dashboard from './views/Dashboard.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Home,  children: [
    { path: '/', name: 'root', component: Login },
    { path: '/forgot-password', component: ForgotPassword },
    { path: '/register', component: Register }
  ]},
  { path: '/dashboard', meta: { auth: true }, component: Dashboard },
 // { path: '/insurance', component: Deeplink, children: [
 //   { path: '/insurance/:id', component: Deeplink },
 //   { path: '/insurance/:id/:planId', component: Deeplink }
 // ] },
  { path: '/quote', component: Deeplink },
  { path: '/subscription', component: Deeplink },
  { path: '/return/:namespace', meta: { auth: true }, component: Return },
  { path: "*", component: CityRouter }
]

export default new VueRouter({
    routes, // short for `routes: routes`
    mode: 'history'
  })